import { Avatar, Card, CardContent, Flex, Text } from '@pega/cosmos-react-core';

import { StyledMainContent } from './AppShell.styles';

export const DefaultMainContent = ({
  content,
  banners
}: {
  content: string;
  banners?: boolean;
}) => (
  <Flex
    container={{ justify: 'center', alignItems: 'center' }}
    as={StyledMainContent}
    banners={banners}
  >
    <Card>
      <CardContent>
        <Text variant='h2'>{content} content</Text>
      </CardContent>
    </Card>
  </Flex>
);

export const notificationItems = [
  {
    id: '123',
    primary:
      "Dean Thomas mentioned your team in a bug 'Button does not initiate onClick event handler'.",
    secondary: ['BUG-12345', new Date(2020, 8, 31, 13, 23).toDateString()],
    visual: <Avatar name='Dean Thomas' />,
    unread: true
  },
  {
    id: '456',
    primary: "Seth DeAngelo mentioned your team in a bug 'Text variant h1 renders as h3 in DOM'.",
    visual: <Avatar name='Seth DeAngelo' />,
    unread: true
  },
  {
    id: '789',
    primary:
      "Janet Moore mentioned your team in a bug 'Tree expanded state does not match the state that was set on the component'.",
    secondary: ['BUG-12345', new Date(2020, 9, 2, 9, 22).toDateString()],
    visual: <Avatar name='Janet Moore' />,
    unread: true
  },
  {
    id: '000',
    primary: 'You have been awarded Employee of the Month! Congratulations!',
    secondary: [new Date(2020, 9, 8, 14, 46).toDateString()],
    unread: true
  },
  {
    id: '111',
    primary:
      "Dean Thomas mentioned your team in a bug 'Button does not initiate onClick event handler'.",
    secondary: ['BUG-12345', new Date(2020, 8, 31, 13, 23).toDateString()],
    visual: <Avatar name='Dean Thomas' />,
    unread: true
  },
  {
    id: '222',
    primary: "Seth DeAngelo mentioned your team in a bug 'Text variant h1 renders as h3 in DOM'.",
    visual: <Avatar name='Seth DeAngelo' />,
    unread: true
  },
  {
    id: '333',
    primary:
      "Janet Moore mentioned your team in a bug 'Tree expanded state does not match the state that was set on the component'.",
    secondary: ['BUG-12345', new Date(2020, 9, 2, 9, 22).toDateString()],
    visual: <Avatar name='Janet Moore' />,
    unread: true
  },
  {
    id: '444',
    primary: 'You have been awarded Employee of the Month! Congratulations!',
    secondary: [new Date(2020, 9, 8, 14, 46).toDateString()],
    unread: true
  }
];
